/**
 * @copyright 2023 Chris Zuber <admin@kernvalley.us>
 */

export const GOOGLE_CALENDAR = 'https://calendar.google.com/calendar/embed';
export const GOOGLE_MAPS = 'https://www.google.com/maps/embed';
export const YOUTUBE = 'https://www.youtube.com/embed/';
export const YOUTUBE_NO_COOKIE = 'https://www.youtube-nocookie.com/embed/';
